import ImageWithFallBack from "./ImageFallBack";

export default function ReleasedIcon({value}:{value: string}) {
    return(
        <ImageWithFallBack src={`/icons/${value}.png`} alt="" image_type="Release" />
    );
}